import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import { nowAsDate } from 'utils/date/now.util';

const isCardExpired = (expiryMonth, expiryYear) => {
  const now = nowAsDate();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear();

  const expMonth = fromAnyToNumber(expiryMonth);
  const expYear = fromAnyToNumber(expiryYear);

  if (isNaN(expMonth) || isNaN(expYear)) return false;

  return expYear < currentYear || (expYear === currentYear && expMonth < currentMonth);
};

export default isCardExpired;
